const { supportedLocales, ES_US_LOCALE } = require('./i18n.config.js')

const defaultLocale = supportedLocales[supportedLocales.length - 1]

// The flag must be exposed as an env var relative to the process running Next.js
// e.g. USE_ATLAS_TRANSLATIONS=true bun run start
const useAtlasTranslations = process.env.NODE_ENV === 'test' || false

let HybridBackend
let backendConfig
let i18nStore

if (typeof window === 'undefined' && process.env.NEXT_RUNTIME !== 'edge') {
  const path = require('path')
  const fs = require('fs')
  const FsBackendModule = require('i18next-fs-backend')
  const FsBackend = FsBackendModule.default || FsBackendModule
  try {
    i18nStore = require('./i18n-store').i18nStore
  } catch (e) {
    // Ignore in environments where node:async_hooks is unavailable
    console.error('i18n-store load error:', e.message)
  }

  backendConfig = {
    loadPath: path.resolve(__dirname, 'public/locales/{{lng}}/{{ns}}.json'),
    addPath: path.resolve(__dirname, 'public/locales/{{lng}}/{{ns}}.missing.json'),
  }

  HybridBackend = class HybridBackend {
    constructor(services, backendOptions = {}, i18nextOptions = {}) {
      this.fsBackend = new FsBackend(services, backendOptions, i18nextOptions)
      this.type = 'backend'
    }

    init(services, backendOptions, i18nextOptions) {
      this.fsBackend.init(services, backendOptions, i18nextOptions)
    }

    read(language, namespace, callback) {
      const store = i18nStore && i18nStore.getStore()
      const isAtlasEnabled = store && store.useAtlasTranslations !== undefined ? store.useAtlasTranslations : useAtlasTranslations
      if (language === ES_US_LOCALE && isAtlasEnabled) {
        const filePath = path.resolve(__dirname, `public/translations/${ES_US_LOCALE}.json`)
        fs.readFile(filePath, 'utf8', (err, data) => {
          if (err) {
            if (err.code === 'ENOENT') {
              this.fsBackend.read(language, namespace, callback)
              return
            }
            return callback(err, false)
          }
          try {
            const all = JSON.parse(data)
            const result = {}
            // Match keys formatted as "namespace:key"
            const prefix = namespace + ':'

            Object.keys(all).forEach((key) => {
              if (key.startsWith(prefix)) {
                const newKey = key.substring(prefix.length)
                result[newKey] = all[key]
              }
            })
            callback(null, result)
          } catch (e) {
            callback(e, false)
          }
        })
        return
      }

      this.fsBackend.read(language, namespace, callback)
    }

    create(languages, namespace, key, fallbackValue) {
      this.fsBackend.create(languages, namespace, key, fallbackValue)
    }
  }

  HybridBackend.type = 'backend'
}
module.exports = {
  i18n: {
    defaultLocale,
    locales: supportedLocales,
    localeDetection: false,
  },
  backend: backendConfig,
  serializeConfig: false,
  use: HybridBackend ? [HybridBackend] : [],
  react: {
    transWrapTextNodes: 'span',
  },
}
